<template>
<div>
    <Breadcrumbs main="Inventory" title="Product Edit" />
    <div class="container-fluid">
        <div style="padding: 0px 12px; margin-bottom: 16px; display: flex; justify-content: end;">
            <b-button variant="primary" @click="goBack">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <feather type="arrow-left" size="18px"></feather>
                    <h7>Back</h7>
                </div>
            </b-button>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Name</label>
                                        <input class="form-control" type="text" placeholder="Enter product name" v-model="product.name">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>SKU</label>
                                        <input class="form-control" type="text" placeholder="Enter product SKU" v-model="product.sku">
                                    </div>
                                </div>
                                <!-- <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Product Received on</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="product.received_on"></datepicker>
                                    </div>
                                </div> -->
                            </div>

                            <div class="row">
                                <div class="col-sm-5">
                                    <div class="form-group">
                                        <label>Category</label>

                                        <v-select class="custom-vue-select" :options="category_list" label="name" :reduce="category_list => category_list.id" v-model="product.category" placeholder="Select a Category"></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-5">
                                    <div class="form-group">
                                        <label>Subcategory</label>

                                        <v-select class="custom-vue-select" :options="subcategory_list" label="name" :reduce="item => item.id" v-model="product.subcategory" placeholder="Select a Subcategory"></v-select>
                                    </div>
                                </div>

                                <div class="col-sm-2">
                                    <div class="form-group">
                                        <label>Product Unit</label>
                                        <v-select class="custom-vue-select" :options="units" label="name" :reduce="unit => unit.name" v-model="product.unit" placeholder="Select a unit" taggable
                                        :create-option="(newValue) => ({ name: newValue })"></v-select>
                                    </div>
                                </div>
                               
                            </div>

                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Brand</label>
                                        <input class="form-control" type="text" placeholder="Enter Brand name" v-model="product.brand">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Distributor</label>
                                        <input class="form-control" type="text" placeholder="Enter product distributor" v-model="product.distributor">
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Origin</label>
                                        <input class="form-control" type="text" placeholder="Enter product origin" v-model="product.origin">
                                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Product Description</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter product description..." rows="2" v-model="product.description"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>Cost Price</label>
                                        <input type="number" class="form-control" placeholder="Enter cost price" v-model.number="product.cost_price" min="0" step="1">
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>Selling Price</label>
                                        <input type="number" class="form-control" placeholder="Enter selling price" v-model.number="product.sell_price" min="0" step="1">
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>Offer Price</label>
                                        <input type="number" class="form-control" placeholder="Enter offer price" v-model.number="product.offer_price" min="0" step="1">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>Stock Quantity</label>
                                        <input type="number" class="form-control" placeholder="Enter stock quantity" v-model.number="product.stock_quantity" min="0" step="1">
                                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="mb-2 font-semibold">Upload Photo</label>

                                        <div class="upload-wrapper ">
                                         

                                            <!-- Upload Input -->
                                            <div class="upload-box">
                                                <input type="file" accept="image/*" @change="uploadFile" class="form-control">
                                            </div>

                                            <div class="preview-box" v-if="product.image || currentImage">
                                                <img :src="product.image ? product.image : currentImage" class="preview-img" alt="Product Preview">
                                            </div>

                                            <!-- Image Preview -->
                                            <!-- <div class="preview-box" v-if="currentImage || product.image">
                                                <img v-if="currentImage && !product.image" :src="currentImage" class="preview-img" alt="Product Preview">
                                                <img v-if="!currentImage && product.image" :src="product.image" class="preview-img" alt="Product Preview">
                                            </div> -->

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Purchase Description</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter purchase description..." rows="2" v-model="product.purchase_description"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Sell Description</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter sell description..." rows="2" v-model="product.sell_description"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Tags</label>

                                        <div class="d-flex mb-2">
                                            <input type="text" class="form-control" placeholder="Enter tag" v-model="tagInput" @keyup.enter="addTag" />

                                            <button type="button" class="btn btn-primary ms-2" @click="addTag">
                                                Add
                                            </button>
                                        </div>

                                        <!-- Tag List -->
                                        <div class="d-flex flex-wrap" style="gap: 5px;">
                                            <span v-for="(tag, index) in product?.tags" :key="index" class="d-flex flex-wrap align-items-center" style="background: #FFF0F0;padding: 8px 12px; border-radius: 12px;">
                                                #{{ tag }}
                                                <feather type="minus" size="14px" style="color: #000000; cursor: pointer;" @click="removeTag(index)" class="ml-2"></feather>

                                            </span>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="handleSubmit()" class="btn btn-success mr-3">Update</button>
                                        <router-link to="/inventory/product/list">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import {
    computed
} from "vue";
import moment from "moment";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {
    myHost
} from '../../../../_helpers/host'
export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        'v-select': vSelect
    },

    data() {
        return {
            host: myHost.host,
            product: {
                name: '',
                sku: '',
                // received_on:null,
                category: null,
                subcategory: null,

                description: '',

                brand: '',
                unit: '',
                origin: '',
                distributor: '',

                sell_description: '',
                purchase_description: '',

                sell_price: null,
                cost_price: null,
                offer_price: null,

                stock_quantity: 0,

                tags: [],
                tagInput: '',
                image: null
            },
            // units: [
                // 'pcs',
                // 'kg',
                // 'litre',
                // 'box',
                // 'set',
                // 'metre',
                // 'pack',
                // 'other'
            // ],
            selectedFileName: '',
            currentImage: null,

        };
    },

    computed: {
        ...mapState({
            category_list: state => state.inventory.categories,
            subcategory_list: state => state.inventory.sub_categories,
            details: state => state.inventory.product_details,
            units: state => state.inventory.inventoryUnits
        })
    },

    mounted() {
        this.$store.dispatch("inventory/fetchCategories")
        this.$store.dispatch("inventory/fetchProductDetails", this.$route.params.id)
        this.$store.dispatch("inventory/fetchInvertoryUnits")
    },

    watch: {
        details(newVal, oldVal) {
            if (!newVal) return
            this.currentImage = this.host + newVal.image,
            this.product = {
                name: newVal.name || '',
                sku: newVal.sku || '',
                category: newVal.category ?.id || null,
                subcategory: newVal.subcategory ?.id || null,

                description: newVal.description || '',
                // received_on : newVal.received_on || null,

                brand: newVal.brand || '',
                unit: newVal.unit || '',
                origin: newVal.origin || '',
                distributor: newVal.distributor || '',

                sell_description: newVal.sell_description || '',
                purchase_description: newVal.purchase_description || '',

                sell_price: newVal.sell_price || null,
                cost_price: newVal.cost_price || null,
                offer_price: newVal.offer_price || null,

                stock_quantity: newVal.stock_quantity || 0,

                tags: newVal.tags || []
            }
        },
        'product.category'(newVal) {
            if (newVal) {
                this.fetchSubCategory(newVal)
            }
        }
    },

    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/dashboard');
            }
        },
        uploadFile(e) {
            const image = e.target.files[0];
            this.selectedFileName = image.name
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.product.image = e.target.result;
            };
        },
        addTag() {
            const tag = this.tagInput.trim()

            if (!tag) return

            if (!this.product.tags.includes(tag)) {
                this.product.tags.push(tag)
            }

            this.tagInput = ''
        },

        removeTag(index) {
            this.product.tags.splice(index, 1)
        },
        fetchSubCategory(val) {
            this.$store.dispatch("inventory/fetchSubCatByCat", val)
        },

        handleSubmit() {
            // if (this.product.received_on !== null) {
            //     this.product.received_on = moment(String(this.product.received_on)).format("YYYY-MM-DD");
            // }
            this.$store.dispatch("inventory/updateProduct", {
                id: this.$route.params.id,
                product: this.product
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    setTimeout(() => {
                        this.$router.back()
                    }, 2000)

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

        },

    }
};
</script>

<style scoped>
.upload-wrapper {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
}

.preview-box {
    width: 120px;
    height: 120px;
    border: 1px dashed #dcdcdc;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafafa;
}

.preview-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    padding: 4px;
}
</style>
